import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges } from '@angular/core'
import { FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms'
import * as _ from 'lodash'
import { Observable, Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { JSONRpcResponse } from '../../../Interfaces/JSONRpcResponse'
import { DialogService, UtilitaryService } from '../../../services'
import { FormAtylBase } from '../../form-atyl-base'
import { FormAtylRestriction } from '../../form-atyl-restriction'
import { AtylService } from '../../service/atyl.service'
import { FormDialogFormulaireComponent } from '../form-dialog/form-dialog-formulaire/form-dialog-formulaire.component'
import { FormDialogSecteurComponent } from '../form-dialog/form-dialog-secteur/form-dialog-secteur.component'




@Component({
	selector: 'app-form-atyl-input',
	templateUrl: './sub-form-atyl-input.component.html',
	styleUrls: ['./sub-form-atyl-input.component.css'],
})
export class SubFormAtylInputComponent implements OnChanges {
	@Input() forminput: FormAtylBase<any>
	@Input() form: FormGroup

	filteredOptionsCode: Observable<any>
	filteredOptionsVille: any
	filteredOptionsRue: Observable<any>
	autocompSelectList: any
	tempResSelectList: any
	filteredSelectionList: any = [];
	listCardSelectionList: any = [];
	isEditable: boolean = true;
	villes: any[] = [];
	rues: any[] = [];

	init: boolean = true;

	checkSecteur: string = 'row';
	addSelection: any
	columns: any = [];
	data: any = [];
	length: number = 0;
	Pagination: number = 0;
	currentPage: number = 0;
	inited = new EventEmitter<any>();

	private debounce: Subject<string> = new Subject();

	constructor(
		private atylService: AtylService,
		private cdr: ChangeDetectorRef,
		private utilities: UtilitaryService,
		private dialogService: DialogService
	) { }

	ngOnInit() {
		this.debounce.pipe(
			debounceTime(1000)
		).subscribe(search => {
			if (search.length > 0) {
				this.atylService.getListeSelection(this.forminput.options['typelist'], search,null,this.forminput.options).subscribe((result: JSONRpcResponse) => {
					let keyName = ''
					_.forEach(result.result.columns, (column, index) => {
						if (column.primary)
							keyName = column.id
					})
					let autoList = []
					_.forEach(result.result.datas.datas, (data, index) => {
						autoList.push({
							key: data[keyName],
							value: data.search
						})
					})
					this.autocompSelectList = autoList
					this.tempResSelectList = result.result
					this.tempResSelectList.keyName = keyName
					this.cdr.detectChanges()
				})
			}
			else {

			}
		})
	}


	ngOnChanges() {
		if (this.forminput && this.forminput.type == 'adresse') {
			let codepost = ''
			let ville = ''

			if (this.forminput.value) {
				if (this.forminput.value['code'])
					codepost = this.forminput.value['code']
				if (this.forminput.value['ville'])
					ville = this.forminput.value['ville']
			}
			this.atylService.getCodePostal(codepost).subscribe((result: JSONRpcResponse) => {
				this.utilities.log(this.forminput.ID)
				this.filteredOptionsCode = result.result
				if (this.forminput.value && this.forminput.value['code'])
					this.form.get(this.forminput.ID).get('code').setValue(codepost)
			})
			this.atylService.getVilles('').subscribe((result: JSONRpcResponse) => {
				this.filteredOptionsVille = result.result
				if (this.forminput.value && this.forminput.value['ville']) {
					this.form.get(this.forminput.ID).get('ville').setValue(ville)

					this.form.get(this.forminput.ID).get('num').enable()
					this.form.get(this.forminput.ID).get('comp').enable()
					this.form.get(this.forminput.ID).get('rue').enable()
					if (this.forminput.value && this.forminput.value['ville']) {
						this.getRuesByVille(this.forminput.value['ville'], this.forminput.ID)
					}
				}
			})
		}
		if (this.forminput && this.forminput.type == 'selectionlist') {
			this.filteredSelectionList = this.forminput.value ? Array.from(this.forminput.value) : []
			this.utilities.log(this.filteredSelectionList)
			this.atylService.getListeSelection(this.forminput.options['typelist'], '').subscribe((res: JSONRpcResponse) => {
				this.columns = res.result.columns
				this.columns.push({ 'id': 'Remove', 'label': '', 'visible': 'true' })
				this.getDataPage(0, true)
				this.inited.emit(res.result)
				if (res.result.options.add)
					this.addSelection = res.result.options.add
				this.utilities.log('l', this.length)
				this.utilities.log('get:liste', this.currentPage, this.length, this.columns, this.data)
			})
		}
	}
	//Check validation du champ dans le formulaire angular
	get isValid() {
		if (this.forminput && this.form.get(this.forminput.ID).touched)
			return this.form.get(this.forminput.ID).valid
		else
			return true
		/*else(this.forminput && this.forminput.deepNested !== '')
		  return this.form.get(this.forminput.deepNested).valid; */
	}

	//Affichage error validation du champ avec le message custom d'error provenant du JSON
	get errorMessage() {
		if (this.forminput && this.form.controls[this.forminput.ID].errors != null) {
			return this.HandlerValidatorInputErrors(this.forminput.restrictions, this.form.controls[this.forminput.ID].errors)
		}
	}

	//Fonction d'execution de code provenant du backoffice, trigger dès le changement de valeur du champ
	CustomBehaviourHandler(newObj, customBehaviour) {
        if (customBehaviour) {
            console.log("customBehaviour field2",customBehaviour);
            try {
                var js=customBehaviour;
                //js+="\njcustomBehavior();"
               eval(js);
                
            }
           catch (err) {
               console.log("error customBehaviour",err,customBehaviour)
            }
    		//eval(customBehaviour)
		}
	}

	HandlerValidatorInputErrors(restrictions: FormAtylRestriction<any>[], errors: ValidationErrors) {
		const listErrors = []
		const typeRestrict = Object.getOwnPropertyNames(errors)[0]
		if (Array.isArray(restrictions) && restrictions) {
			restrictions.forEach((error, index) => {
				if (error.type == typeRestrict)
					listErrors.push(error.messageError)
			})
		}

		return listErrors
	}
	triggerSelectCodePost(zip: any) {
		this.atylService.getCodePostal(zip).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsCode = result.result
			this.cdr.detectChanges()
		})
	}
	getVilleByCP(id: any, nameinput: string) {
		this.atylService.getVillesByCP(id).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsVille = result
			if (this.init && this.forminput.value && this.forminput.value['ville']) {
				(this.form.controls[nameinput] as FormGroup).controls['ville'].setValue(this.forminput.value['ville'])
				if (!this.forminput.value['rue'])
					this.init = false
			}
			else {
				(this.form.controls[nameinput] as FormGroup).controls['ville'].patchValue(null);
				(this.form.controls[nameinput] as FormGroup).controls['rue'].patchValue(null)
			}
		})
	}

	triggerSelectVille(ville: any, nameinput: string) {
		(this.form.controls[nameinput] as FormGroup).controls['num'].disable();
		(this.form.controls[nameinput] as FormGroup).controls['comp'].disable();
		(this.form.controls[nameinput] as FormGroup).controls['rue'].disable()
		this.atylService.getVilles(ville).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsVille = result
			this.cdr.detectChanges()
		})
	}

	getCPbyVille(ville: any, nameinput: string) {
		this.filteredOptionsVille.result.forEach((element) => {
			if (element.id == ville) {
				(this.form.controls[nameinput] as FormGroup).controls['code'].setValue(element.codepostals[0].id);
				(this.form.controls[nameinput] as FormGroup).controls['num'].enable();
				(this.form.controls[nameinput] as FormGroup).controls['comp'].enable();
				(this.form.controls[nameinput] as FormGroup).controls['rue'].enable()
				this.getRuesByVille(ville, nameinput)
			}
		})
	}

	displayAutoVille(villeid?: any): string | undefined {
		let villeselected
		if (this.filteredOptionsVille) {
			this.filteredOptionsVille.result.forEach((ville, index) => {
				if (ville.id === villeid)
					villeselected = ville
			})
		}
		return villeselected ? villeselected.libelle : undefined
	}

	getRuesByVille(villeid: any, nameinput: string) {
		if (villeid) {
			this.atylService.getRueByVille(villeid).subscribe((result: JSONRpcResponse) => {
				this.filteredOptionsRue = result.result[0].rues
				if (this.init && this.forminput.value && this.forminput.value['rue']) {
					(this.form.controls[nameinput] as FormGroup).controls['rue'].setValue(this.forminput.value['rue'])
					this.init = false
					this.cdr.detectChanges()
				}
				else
					(this.form.controls[nameinput] as FormGroup).controls['rue'].patchValue(null);
				(this.form.controls[nameinput] as FormGroup).controls['num'].enable();
				(this.form.controls[nameinput] as FormGroup).controls['comp'].enable();
				(this.form.controls[nameinput] as FormGroup).controls['rue'].enable()
			})
		}
	}

	triggerSelectRue(rue: any, nameinput: string) {
		this.atylService.getRues(rue, (this.form.controls[nameinput] as FormGroup).controls['ville'].value).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsRue = result.result
			this.cdr.detectChanges()
		})
	}

	displayAutoRue(rueid?: any): string | undefined {
		let rueselected
		if (this.filteredOptionsRue) {
			this.filteredOptionsRue.forEach((rue) => {
				if (rue.id === rueid)
					rueselected = rue
			})
		}
		return rueselected ? rueselected.libelle : undefined
	}

	dialogSecteur(nameinput: any, event: any) {
		this.dialogService.open(FormDialogSecteurComponent, {
			data: {
				'name': nameinput,
				'controls': (this.form.controls[nameinput] as FormGroup).controls
			},
			draggable: true,
			minimizable: true,
			maximizable: true,
		}, (result: any) => {
			this.checkSecteur = result
			this.cdr.detectChanges()
		})
	}

	dialogAddSelection(nameinput: any) {
		this.dialogService.open(FormDialogFormulaireComponent, {
			data: {
				'typeDemande': this.addSelection.params.type,
				'typeFormulaire': this.addSelection.params.options.form,
				'title': this.addSelection.title
			},
			height: '90vh',
			width: '80vw'
		})
	}

	triggerAutocompSelectionList(search: any, nameinput: string) {
		this.debounce.next(search)
	}

	displayAutoSelectList(key?: any): string | undefined {
		let selected
		if (this.autocompSelectList) {
			this.autocompSelectList.forEach((select) => {
				if (select.key === key)
					selected = select
			})
		}
		return selected ? selected.search : undefined
	}

	addToSelectionList(id: any, input: any) {
		_.forEach(this.tempResSelectList.datas.datas, (res, index) => {
			if (res[this.tempResSelectList.keyName] === id) {
				if (input.options.type === 'list') {
					this.filteredSelectionList.push(res);
					(this.form.controls[input.ID] as FormControl).setValue(this.data)
					this.utilities.log(this.filteredSelectionList, this.form.controls[input.ID])
					this.getDataPage()
					this.inited.emit(this.filteredSelectionList)
				}
				else if (input.options.type === 'card') {
					this.listCardSelectionList.push(res)
					this.cdr.detectChanges()
				}
			}
		})
	}

	onPaged(table: any) {
		this.utilities.log('table', table)

		this.getDataPage(table.currentPage)
	}
	getDataPage(page: number = 0, init: boolean = false) {

		this.data = this.filteredSelectionList
		this.length = this.filteredSelectionList.length
		this.currentPage = 0
		this.Pagination = 5

		this.utilities.log('l', this.length)
		this.utilities.log('get:liste', this.currentPage, this.length, this.columns, this.data)

		this.cdr.detectChanges()
	}
	getInitedEmitter() {
		return this.inited
	}

	onRowClicked(row: any) {
	}
	removeLine(cell: any, nameinput: string) {

		let indexRemove
		this.filteredSelectionList.forEach((row, index) => {
			this.utilities.log(row)
			if (row.id == cell.id) {
				indexRemove = index
			}
		})
		this.filteredSelectionList.splice(indexRemove, 1);
		(this.form.controls[nameinput] as FormControl).setValue(JSON.stringify(this.filteredSelectionList))
		this.getDataPage()
		this.inited.emit(this.filteredSelectionList)
		this.utilities.log((this.form.controls[nameinput] as FormArray).value)
	}

	getSubmittedEmitter() {
		return false
	}

	onSubmit(values: any) {
	}


	onLoaded(loaded: boolean) {
		if (loaded)
			this.cdr.markForCheck()
	}
}
